
// 招聘信息
const recruitmentInformation = {
  titleOne: 'Wuxi Kelke Talent Declaration',
  contentOne: `
  <p>In the star sea of precision control valves and industrial fluid technology, talent is the engine of Kelke's anchoring innovation and global success. As a benchmark enterprise of technology integration between China and Canada, we know that every low-temperature cryogenic valve that breaks the import monopoly and every set of intelligent flow control system that serves national energy projects come from an elite team that dares to break into no man's land of technology. Here, you write not only the valve parameters, but also the industrial epic of China's wisdom.<p>
  <ul style="margin-top: 20px;display:block;">
    <li style="">With the vision of "global leader in fluid control solutions", we provide talents with.</li>
    <li style="">The temperature of the home: monthly technical salon, annual "Golden Wrench" Engineer festival, all staff equity incentive plan, so that core technology and humanistic care co-exist.</li>
    <li style="">Business stage: Deeply involved in the research and development of nuclear power, LNG, supercritical and other special valves, with technological breakthroughs to define industry standards.</li>
    <li style="">Fertile soil for growth: "Dual channel promotion system" (technical experts/management elites) + transnational technical exchange program, allowing engineers to resonate with the world's top laboratories.</li>
    <li style="">Value feedback: "skill certification subsidy", "patent achievement dividend", "major project key bonus" three levels of incentive, salary competitiveness ranked in the Yangtze River Delta equipment manufacturing TOP10%.</li>
  </ul>
  `,
  tableHead: [
    'Job title',
    'Work place',
    'Number of people in need',
    'Work experience',
    'Educational requirement',
    'Specific requirements',
    'Controls',
  ],
  tableActionBtn: [
    'more'
  ],
  dialog: {
    title: 'Job description',
    content: `
    Position: Instrument manufacturing process technician, responsible for the process technology in the instrument manufacturing process. It includes the manufacturing process plan of instrument parts, the process implementation and the design and manufacturing implementation of the process equipment required in the manufacturing process of instrument parts.<br />
    Requirements: Have a solid technical level and ability of senior fitters, have the ability to understand the design technology and the comprehension of related fields. Work seriously and responsibly, steadfast and dedicated.
    `,
    btn: 'I want to apply'
  },
  list: [
    {
      title: 'Working hours',
      content: 'Are you looking for a business that can offer you different development potential? Do you want to build your future path and career ahead of time? Wuxi KELK is the right place for you, and qualified and motivated employees are the cornerstone of our business success'
    },
    {
      title: 'Campus internship',
      content: 'Your career can start sooner than you think. While studying at school, you have the opportunity to accumulate valuable practical experience through internships in our company. This experience will make it easier for you to work in the future and maybe even become part of our team.'
    }
  ]
}

// 校园实习
const campusInternship = {
  title: 'Intern Program - Grow together with the big country',
  /* content: `
  <p>Between the lab and the shop floor, are you looking forward to a real industrial revolution experience? Wuxi Kelke opens the real field of special valve research and development to students - participate in the prototype test of low temperature cryovalve in the API 6D certification laboratory, learn the design of intelligent flow control system in the work order of ten million tons of LNG project, and even explore the material limit of supercritical valve with the national energy engineering team.</p>
  <div>
    <ul style="margin-top: 20px;display:block;text-align:left;">
      <li style="font-weight:600;">You are not a bystander, but the seed of the future "Golden Wrench Engineer" :</li>
      <li>Each intern will be matched with a technical tutor to independently undertake sub-projects (such as bellows seal life optimization, butterfly valve fluid simulation);</li>
      <li>Participate in the cloud seminar of Canada Technology Center, excellent candidates will pass through the "Young Eagle Program", and enjoy the dual channel promotion qualification of project manager/R & D engineer upon graduation;</li>
      <li style="">Your thinking on carbon neutrality and insight into intelligent manufacturing are the source of inspiration for the next generation of domestic high-end valve iterations.</li>
      <li style="">Breaking technical barriers with a young edge - KELK internship is the first "industry standard" in your career.</li>
    </ul>
  </div>
  `, */
  content: `
  <p>Between the lab and the shop floor, are you looking forward to a real industrial revolution experience? Wuxi Kelke opens the real field of special valve research and development to students - participate in the prototype test of low temperature cryovalve in the API 6D certification laboratory, learn the design of intelligent flow control system in the work order of ten million tons of LNG project, and even explore the material limit of supercritical valve with the national energy engineering team.</p>
  <div>
    <ul style="margin-top: 20px;display:block;">
      <li style="">You are not a bystander, but the seed of the future "Golden Wrench Engineer".</li>
      <li>Each intern will be matched with a technical tutor to independently undertake sub-projects (such as bellows seal life optimization, butterfly valve fluid simulation).</li>
      <li>Participate in the cloud seminar of Canada Technology Center, excellent candidates will pass through the "Young Eagle Program", and enjoy the dual channel promotion qualification of project manager/R & D engineer upon graduation.</li>
      <li style="">Your thinking on carbon neutrality and insight into intelligent manufacturing are the source of inspiration for the next generation of domestic high-end valve iterations.</li>
      <li style="">Breaking technical barriers with a young edge - KELK internship is the first "industry standard" in your career.</li>
    </ul>
  </div>
  `,
  titleOne: 'Optional department',
  contentOne: 'Do you want to test whether the theoretical knowledge you gained at university can be used in the real world? You can choose the right department through your own major',
  listOne: [
    'IT',
    'Finance',
    'Administration',
    'Production management',
    'Sell',
    'Purchase',
    'Human resources',
    'Production - Process',
    'Marketplace',
    'Business development',
    'Supply chain management',
  ],
  callMe: {
    title: 'Contact us',
    contentOne: 'Company name: Wuxi Kelke Instrument Valve Co., LTD Address: No.6, Moral Road, Hongshan Town, New District, Wuxi City, Jiangsu Province（214115）',
    contentTwo: 'Company email: info@kelkflow.com.cn Company website: www.kelkflow.com.cn',
    contentThree: 'Company telephone：+86-(0)510-85141699（Manager Du）',
  },
  group1: {
    title: 'You need to provide',
    list: [
      'Engineering science degree, business administration degree or equivalent qualification',
      'In addition to the internal needs of the production department, you need to ensure a minimum of 1-3 internship hours per week',
      'Relevant practical or theoretical experience in your chosen department',
    ],
  },
  group2: {
    title: 'We will provide',
    list: [
      'The opportunity to get involved in practical matters',
      'A good opportunity to exercise personal work independence',
      'Harmonious working environment',
    ],
  },
  footContent: `
  <p>Join our dynamic international team!</p>
  <p>Does Wuxi KELK have a suitable job opportunity for you? You will find the latest internship information in the job postings.</p>
  <p>Send us your application materials, including relevant documents, indicating your chosen work department. We will check each application one by one to see if there is a suitable job for you.</p>
  `
}

// 工作时光
const workingHours = {
  title: 'Wuxi KELK invites you to start the future together',
  content: `
  Are you looking for a stage that inspires potential and links the frontiers of global industry? Wuxi Kelke - the Canadian technology benchmarking enterprise that "breaks the import monopoly of low temperature cryovalve and defines the industry standard of supercritical high pressure valve" is providing unlimited possibilities for every engineer who pursues excellence.<br />
  <p style="margin-top: 20px;display:block;">
    Here, you will work side by side with the "national energy project team" to participate in the research and development of special valves such as nuclear power, LNG and hydrogen energy storage and transportation.<br />
    You will be able to think with the Canadian Technology Centre in the API 6D Certified Laboratory through the Dual-Track Growth Program (Technical Expert Certification Pathway/Multinational Project Manager Incubation).<br />
    You will see how a self-designed labyrinth regulator can save 30% of Global 500 customers' energy consumption. We firmly believe that every seed that dares to think and act is worthy of being given the power to break ground.<br />
    Join KELK, in the name of "Golden wrench engineer", in the wave of intelligent manufacturing, write the world coordinates belonging to China's high-end valve technology.
  </p>
  `,
  group: {
    title: 'We need engineers who are curious and motivated about the future',
    content: 'Do you want to test whether the theoretical knowledge you gained at university can be used in the real world? You can choose the right department through your own major',
    list: [
      'Infrastructure & Development',
      'Production',
      'Plan',
      'Industrial engineering',
      'Marketplace',
      'Export',
      'Quality inspection',
    ],
  },
  callMe: {
    title: 'Contact us',
    contentOne: 'Company name: Wuxi Kelke Instrument Valve Co., LTD Address: No.6, Moral Road, Hongshan Town, New District, Wuxi City, Jiangsu Province（214115）',
    contentTwo: 'Company email: info@kelkflow.com.cn Company website: www.kelkflow.com.cn',
    contentThree: 'Company telephone：+86-(0)510-85141699（Manager Du）',
  },
  group1: {
    title: 'You need to provide',
    list: [
      'Engineering science degree, business administration degree or equivalent qualification',
      'In addition to the internal needs of the production department, you need to ensure a minimum of 1-3 internship hours per week',
      'Relevant practical or theoretical experience in your chosen department',
    ],
  },
  group2: {
    title: 'We will provide',
    list: [
      'The opportunity to get involved in practical matters',
      'A good opportunity to exercise personal work independence',
      'Harmonious working environment',
    ],
  },
  footContent: `
  <p>Join our dynamic international team!</p>
  <p>Does Wuxi KELK have a suitable job opportunity for you? You will find the latest internship information in the job postings.</p>
  <p>Send us your application materials, including relevant documents, indicating your chosen work department. We will check each application one by one to see if there is a suitable job for you.</p>
  `
}

// 求职问题
const jobSearchProblem = {
  title: 'How to apply',
  content: 'You can participate in the following ways. If you are applying by email, please send your resume in Word or PDF format',
  callMe: {
    title: 'Contact us',
    contentOne: 'Company name: Wuxi Kelke Instrument Valve Co., LTD Address: No.6, Moral Road, Hongshan Town, New District, Wuxi City, Jiangsu Province（214115）',
    contentTwo: 'Company email: info@kelkflow.com.cn Company website: www.kelkflow.com.cn',
    contentThree: 'Company telephone：+86-(0)510-85141699（Manager Du）',
  },
  zhaoPing: {
    title: 'Recruitment position',
    content: 'Recruitment information please click'
  },
  group: [
    {
      id:1,
      title:'Can I take the initiative to send an application to your company?',
      con:'Yes, you can send an application voluntarily. We will determine if there is a suitable position for you. We will get back to you, but please be patient as it will take longer to check if a particular location is right for you.'
    },
    {
      id:2,
      title:'What information and documentation do I need for my job application?',
      con:'You will need to prepare a resume, relevant documents, a cover letter (explaining your reasons for applying), and a report certificate. Please state in your application information: when to start the job, salary requirements and need our attention'
    },
    {
      id:3,
      title:'When should I send in my application?',
      con:'We do not have a deadline for sending applications. However, if you are applying to us on your own initiative, you should send your resume 2-3 months before you are available for employment. If the vacancy is filled, you will not find the relevant recruitment information on our website.'
    },
    {
      id:4,
      title:'What happens when my application is sent?',
      con:'When we receive your application, it will be automatically checked in our database. If you meet our job requirements, we will contact you for a phone interview to ask some preliminary and simple questions. If there are no further questions and you are also interested in your resume, we will invite you to a first round interview. If you pass this interview, we will arrange a second interview. Whether you pass the interview depends on whether you are suitable for the position.'
    },
    {
      id:5,
      title:'How soon can I get a response?',
      con:'If you are applying online, you will automatically receive a return receipt. Those who send an email will receive a temporary reply to the message. In general, we need four weeks to process your application. It may take longer if special circumstances arise. We sincerely hope that you can understand this'
    },
    {
      id:6,
      title:'How can I keep my information safe?',
      con:'The data received by KELK is processed in accordance with data protection laws. Your personal information will always be kept confidential and will only be used for recruitment purposes.'
    },
    {
      id:7,
      title:'How is new employee training conducted?',
      con:'When you start working at KELK in Wuxi, you will have a general understanding of us: get to know your new colleagues, our product information, the scope of use and the organizational structure, workflow and service processes of KELK in Wuxi. In addition, as a vocational training, you will also participate in our comprehensive guidance training, so that you have a systematic understanding of each department. At the same time, experienced staff in the department will also help you.'
    },
  ]
}


export default {
  title: 'Join KELK',
  tabs: [
    'Recruitment information',
    'Campus internship',
    'Working hours',
    'Job search problem',
  ],
  // 招聘信息
  recruitmentInformation,
  // 校园实习
  campusInternship,
  // 工作时光
  workingHours,
  // 求职问题
  jobSearchProblem,
}


// WEBPACK FOOTER //
// ./src/config/lang/en/joinInPage.js